<style lang="scss">

</style>
<template>
    <div class="user-attribute-item">
      <!-- 项目：国家及地区 -->
      <div class="module-item first">
        <!-- 项目名称 -->
        <strong class="item-name">{{ dataType.label }}</strong>
        <!-- 项目内容 -->
        <div class="item-content select-wrap">
          <div :class="['select-box', dataType.value]" @click="showModal">
            <span v-if="all">{{ dataType.placeholder }}</span>
            <Tag
                v-else
                closable v-for="(item, index) in tagList"
                @on-close="deleteTag(item, index)"
                :key="index"
            >{{item.value}}</Tag>
            <Icon type="ios-arrow-down"></Icon>
          </div>
        </div>
        <!-- 项目操作按钮 -->
        <i class="delete-item iconfont icon-removed" @click="deleteItem"></i>
      </div>

    <!-- modal框 -->
    <Modal class="attributeModal" v-model="showSelector" @on-cancel="cancel">
      <p slot="header" style="text-align:center">
        <span>{{ $t('userGroup.choose') }}{{name}}</span>
      </p>
      <div class="select-title select-item">
        <Checkbox v-model="all" @click.prevent.native="allchecked()">
          <span><strong>{{ $t('userGroup.all') }}{{name}}</strong></span>
        </Checkbox>
        <Input icon="ios-search" v-model="searchKey" :placeholder="$t('filter.search')" class="search" style="width:210px;"></Input>
      </div>
      <div v-for="item in filterList" class="select-item" :key="item.index">
        <Checkbox v-model="item.checked" @click.prevent.native="changeChecked(item.index)">
          <span>{{item.value}}</span>
        </Checkbox>
        <a v-if="item.children !== undefined && item.children.length > 0" @click.prevent="expandItem(item.index)" class="r">
          <Icon type="md-arrow-dropdown" :class="['subclose',item.expand?'subopen':'']" style="font-size: 20px"></Icon>
        </a>
        <Checkbox-group v-if="item.expand" v-model="subselected">
          <Checkbox v-for="subitem in filterChildren" :label="subitem.index" :key="subitem.index">
            <span>{{subitem.value}}</span>
          </Checkbox>
        </Checkbox-group>
      </div>
      <div v-if="list.length == 0" class="loading">
        <Spin fix v-if="showLoading">
          <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        {{ $t('common.nodata') }}
      </div>
      <div slot="footer">
        <span class="l"><strong>{{ $t('userGroup.selected') }}{{name}}  {{selected.length + subselected.length}}</strong></span>
        <i-button type="text" @click="cancel">{{ $t('common.cancel') }}</i-button>
        <i-button type="primary" @click="save">{{ $t('common.certain') }}</i-button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import util from '../../libs/util';
  import bus from '../../libs/bus';

  export default {
    name: 'user-attribute-item',
    data() {
      return {
        keys: [],
        model1: '',
        showSelector: false, // 弹出框展示

        // modal框相关
        name: '', // 弹出框title
        all: true,
        searchKey: '', // 搜索框匹配
        showLoading: true,
        list: [],
        // 用作保存改变前的各项数据
        preTmp: {
          preList: [],
          preAll: null,
          preSelect: [],
          subselected: [],
        },
        province: [],
        selected: [],
        subselected: [],
        // tag相关
        tagList: [],
        // 从下拉列表新建“国家及地区”标识
        addRegionFlag: false,

        // 以下用作保存请求的原始数据
        partnerList: [],
        osList: [],
        mobileList: [],
        ispList: [],
        regionList: {},
      };
    },
    props: {
      dataType: {
        type: Object,
        default() {
          return {};
        },
      },
      index: {
        type: Number,
      },
      contentData: Object,
    },
    components: {

    },
    filters: {

    },
    computed: {
      // 分群列表传递相关参数,有则为编辑，无则为新建
      userGroupId() {
        // eslint-disable-next-line
        return bus.setUserGroupId || sessionStorage.getItem('_app_setUserGroupId') || bus.sessionStorage._app_setUserGroupId;
      },
      subKey() {
        if (this.searchKey === '中国') {
          return '';
        }
        return this.searchKey;
      },
      // 用于弹出框搜索“国家及地区”的中国省份
      filterChildren() {
        let children = [];
        for (let i = 0; i < this.list.length; i += 1) {
          if (this.list[i].children) {
            children = this.list[i].children;
            break;
          }
        }
        // eslint-disable-next-line
        return children.filter((item) => {
          return item.value.toLowerCase().indexOf(this.subKey.toLowerCase()) !== -1;
        });
      },
      // 用于弹出框搜索
      filterList() {
        let children = [];
        for (let i = 0; i < this.list.length; i += 1) {
          if (this.list[i].children) {
            children = this.list[i].children;
            break;
          }
        }
        let flag = false;
        children.forEach((v) => {
          if (v.value.toLowerCase().indexOf(this.searchKey.toLowerCase()) !== -1) {
            flag = true;
          }
        });
        // eslint-disable-next-line
        return this.list.filter((item) => {
          if (flag && item.children) {
            // eslint-disable-next-line
            return item.children.filter((data) => {
              return data.value.toLowerCase().indexOf(this.searchKey.toLowerCase()) !== -1;
            });
          }
          return item.value.toLowerCase().indexOf(this.searchKey.toLowerCase()) !== -1;
        });
      },
      // 传出的obj的key值
      keyName() {
        const name = this.dataType.value === 'region' ? 'user_region' : this.dataType.value;
        return name;
      },
    },
    mounted() {
      this.$nextTick(() => {
        bus.$on('selected-attr-item', (val) => {
          if (val === 'region') this.addRegionFlag = true;
          if (this.dataType.value === val) {
            this.getReturnData();
          }
        });
        if (!bus.productInfo.productid) return;
        if (this.contentData) this.renderData();
      });
    },
    beforeDestory() {
      this.$off('delete-attr-item');
      bus.$off('selected-attr-item');
    },
    methods: {
      // 解析表达式渲染
      renderData() {
        const keys = Object.keys(this.contentData);
        switch (keys[0]) {
          case 'partnerId':
            if (this.partnerList.length > 0) {
              this.dealPartnerList(this.partnerList);
            } else {
              this.fetchPartnerData();
            }
            break;
          case 'ispId':
            if (this.ispList.length > 0) {
              this.dealCommonList(this.ispList, 'isp');
            } else {
              this.fetchCommonData('isp');
            }
            break;
          case 'mobileId':
            if (this.mobileList.length > 0) {
              this.dealCommonList(this.mobileList, 'mobile');
            } else {
              this.fetchMobileData();
            }
            break;
          case 'osId':
            if (this.osList.length > 0) {
              this.dealCommonList(this.osList, 'os');
            } else {
              this.fetchCommonData('os');
            }
            break;
          case 'countryId':
          case 'provinceId':
            if (this.regionList.data3701) {
              this.dealRegionList(this.regionList);
            } else {
              this.fetchData('3701');
            }
            break;
          default:
            break;
        }
      },
      // 删除用户属性
      deleteItem() {
        this.$emit('delete-attr-item', this.dataType.value);
      },
      // 展示modal
      showModal() {
        if (this.list.length < 1) {
          if (this.dataType.value === 'region') {
            this.fetchData('3701');
          } else if (this.dataType.value === 'partner_info') {
            this.fetchPartnerData();
          } else if (this.dataType.value === 'mobile_info') {
            this.fetchMobileData();
          } else {
            // 判断当前组件类型，转换参数，以便接口使用
            const urlType = this.dataType.value === 'isp_info' ? 'isp' : 'os';
            this.fetchCommonData(urlType);
          }
        } else {
          this.savePreList();
        }
        this.showSelector = true;
      },
      // 是否获取taglist
      jurgeTaglist() {
        // 若this.contentData为存在表示渲染表达式，否则表示新建
        if (!this.contentData) return;
        if (!this.all) this.getTagList();
      },
      // copy  list 用作取消时赋值
      savePreList() {
        this.preTmp.preList = this.list.length > 0 ? JSON.parse(JSON.stringify(this.list)) : [];
        this.preTmp.subselected = this.subselected.length > 0 ?
        JSON.parse(JSON.stringify(this.subselected)) : [];
        this.preTmp.preAll = this.all;
        this.preTmp.preSelect = JSON.parse(JSON.stringify(this.selected));
      },
      // 获取地区
      fetchData(code) {
        const params = [
          `productid=${bus.productInfo.productid}`,
          `platformid=${bus.platform.toString()}`,
          `serviceCode=${code}`,
          'timeflag=99',
          `lang=${bus.lang === 'zh-CN' ? 'cn' : 'en'}`,
          'versionid=',
          'partnerid=',
        ].join('&');
        util.ajax.post('/app/servlet/TenddataUserSegmentationServlet', params)
        .then((res) => {
          // 将中国放在第一项
          const result = {
            data3701: {},
          };
          result.data3701.data0096 = res.data3701.data0096;
          result.data3701.data0100 = res.data3701.data0100.filter(x => x.key === '4').concat(res.data3701.data0100.filter(x => x.key !== '4'));
          this.regionList = result;
          this.dealRegionList(result);
        });
      },
      // 获取运营商、系统
      fetchCommonData(type) {
        const params = {
          productid: bus.productid,
          platformid: bus.platform.toString(),
        };
        util.ajax.post(`/app/rest/segmentDictionary/${type}`, params).then((res) => {
          this[`${type}List`] = res;
          this.dealCommonList(res, type);
        });
      },
      // 获取渠道
      fetchPartnerData() {
        const params = {
          productid: bus.productid,
          platformid: bus.platform.toString(),
          developerid: bus.developerid,
        };
        util.ajax.get('/app/rest/partner.json/getByProduct', { params }).then((res) => {
          this.partnerList = res;
          this.dealPartnerList(res);
        });
      },
      // 获取机型
      fetchMobileData() {
        const startTime = bus.selectedDate[0];
        const endTime = bus.selectedDate[1];
        const params = {
          metrics: ['launchuser'],
          groupby: 'mobile',
          detail: true,
          conditions: {
            developerid: bus.developerid,
            productid_list: [bus.productInfo.productid],
            platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
            end: endTime,
            start: startTime,
          },
        };
        util.ajax.post('/app/rest/data.json/query', params).then((res) => {
          // 取活跃设备top200
          this.mobileList = res.length > 200 ? res.splice(0, 200) : res;
          this.dealCommonList(this.mobileList, 'mobile');
        });
      },
      // 处理请求的渠道数据
      dealPartnerList(res) {
        this.selected = [];
        /* 渠道isdisplay为0表示显示，1表示隐藏。
        筛选是否是被合并的渠道 (groupid为空或不存在的是未被合并的要展示的渠道,
        groupid === partnerid是合并后的渠道同样要展示)*/
        const result = res.filter(v => (v.isdisplay === 0 && (!v.groupid || v.groupid === '' || v.groupid === v.partnerid)));

        this.list = result.map((x, i) => {
          const item = {
            index: `${i}`,
            key: x.partnerid,
            value: x.displayname ? x.displayname : x.partnername,
            checked: false,
            channelstr: x.channelstr ? x.channelstr : undefined,
          };
          return this.compareData(item, 'partner');
        });
        this.savePreList();
        this.jurgeTaglist();
        if (this.list.length === 0) this.showLoading = false;
      },
      /**
       * 处理请求的运营商、机型、系统数据
       * @param res {Object} 请求的原始数据
       * @param type  {String} 标识运营商、机型、系统的字符
       **/
      dealCommonList(res, type) {
        this.selected = [];
        // 处理机型数据
        if (type === 'mobile') {
          this.list = res.map((x, i) => {
            const item = {
              index: `${i}`,
              key: x.mobile,
              value: x.zh_cn.replace(/^:/, ''),
              checked: false,
            };
            return this.compareData(item, type);
          });
        // 处理运营商、系统数据
        } else {
          this.list = res.map((x, i) => {
            const item = {
              index: `${i}`,
              key: x.key,
              value: x.value,
              checked: false,
            };
            return this.compareData(item, type);
          });
        }
        this.savePreList();
        this.jurgeTaglist();
        if (this.list.length === 0) this.showLoading = false;
      },
      // 处理请求的地区数据
      dealRegionList(res) {
        this.selected = [];
        this.subselected = [];
        this.list = res.data3701.data0100.map((x, i) => {
          const item = {
            index: `${i}`,
            key: x.key,
            value: x.value,
            checked: false,
          };
          const tmp = this.compareData(item, 'country');
          if (x.key === '4') {
            tmp.children = res.data3701.data0096.map((y, j) => {
              const index = `${i}.${j}`;
              const childrenItem = {
                index,
                key: y.key,
                value: y.value,
                checked: false,
                province: true,
              };
              return this.compareData(childrenItem, 'province');
            });
            tmp.expand = true;
          }
          return tmp;
        });
        this.savePreList();
        this.jurgeTaglist();
        if (this.list.length === 0) this.showLoading = false;
      },
      /**
       * 对比传入数据，checkbox打钩
       * @param obj {Object} list的每个对象
       * @param type  {String} key值
       **/
      compareData(obj, type) {
        const item = obj;
        // 此判断为编辑用户分群，且删除国家及地区又创建的判断(直接默认为全选)
        if (this.addRegionFlag && type === 'province') {
          item.checked = true;
          this.jurgeProvince(item);
          return item;
        }
        // （这里为编辑用户分群）如果this.userGroupId存在则遍历contentData，改变选中checkbox状态
        if (this.userGroupId && this.contentData) {
          // $in长度大于0表示非全选
          if (this.contentData[`${type}Id`] && this.contentData[`${type}Id`].$in.length > 0) {
            this.all = false;
            const $in = this.contentData[`${type}Id`].$in;
            for (let j = 0, len = $in.length; j < len; j += 1) {
              if (item.key * 1 === $in[j] * 1) {
                item.checked = true;
                // 判断是否为有省
                this.jurgeProvince(item);
              }
            }
          // 若所接收$in为空数组，表示全选（除了省）
          } else if (this.contentData[`${type}Id`] && this.contentData[`${type}Id`].$in.length <= 0 && type !== 'province') {
            this.all = true;
            item.checked = true;
            this.jurgeProvince(item);
          }
        } else {
          // （这里为新建用户分群）
          item.checked = true;
          this.jurgeProvince(item);
        }
        return item;
      },
      // 判断是否含有省
      jurgeProvince(item) {
        if (item.province) {
          this.subselected.push(item.index);
        } else {
          this.selected.push(item.index);
        }
      },
      // 全选
      allchecked() {
        this.all = !this.all;
        const allFlag = this.all;
        this.selected = allFlag ? this.list.map(x => x.index) : [];
        // eslint-disable-next-line
        for (const item of this.list) {
          item.checked = allFlag;
          if (item.key === '4') {
            this.subselected = item.checked ? item.children.map(x => x.index) : [];
          }
        }
      },
      // modal框取消
      cancel() {
        this.showSelector = false;
        this.list = this.preTmp.preList;
        this.subselected = this.preTmp.subselected;
        this.all = this.preTmp.preAll;
        this.selected = this.preTmp.preSelect;
      },
      // modal框确定
      save() {
        this.showSelector = false;
        // 判断省是否全选
        if (this.keyName === 'user_region' && this.subselected.length < 35) this.all = false;
        if (this.all) {
          // 全选时taglist置空
          this.tagList = [];
        } else {
          this.getTagList();
        }
      },
      // 获取tagList
      getTagList() {
        const result = [];
        this.list.forEach((v) => {
          if (v.checked) {
            result.push(v);
          }
          if (v.children) {
            this.subselected.forEach((value) => {
              const tmp = value.split('.');
              result.push(this.list[tmp[0]].children[tmp[1]]);
            });
          }
        });
        this.tagList = result;
      },
      // checkbox改变选中状态
      changeChecked(index) {
        this.list[index].checked = !this.list[index].checked;
        const result = [];
        let flag = true;
        this.list.forEach((v) => {
          if (v.checked) {
            result.push(v.index);
          } else {
            flag = false;
          }
        });
        this.all = flag;
        this.selected = result;
        // 如果勾选父项，子项全选
        if (this.list[index] && this.list[index].key === '4') {
          this.subselected = this.list[index].checked ?
          this.list[index].children.map(x => x.index) : [];
        }
      },
      expandItem(index) {
        this.list[index].expand = !this.list[index].expand;
      },
      // 删除tag
      deleteTag(item, index) {
        if (item.province) {
          const sub = this.subselected;
          for (let i = 0, len = sub.length; i < len; i += 1) {
            if (item.index === sub[i]) {
              this.subselected.splice(i, 1);
              break;
            }
          }
        } else {
          this.list.forEach((v, i) => {
            if (item.key === v.key) {
              this.list[i].checked = false;
              this.selected.splice(i, 1);
            }
          });
        }
        this.tagList.splice(index, 1);
        this.all = false;
      },
      // 拼接obj
      getReturnData() {
        const name = this.dataType.value;
        // 存储的用户属性对应的id
        let val = null;
        // 存储的用户属性id对应的中文名（用于用户分群列表页hover展示）
        let detail = null;
        if (name === 'region') {
          const province = [];
          const region = [];
          this.subselected.forEach((value) => {
            const tmp = value.split('.');
            province.push(this.list[tmp[0]].children[tmp[1]].key);
            region.push(this.list[tmp[0]].children[tmp[1]].value);
          });
          const country = [];
          this.list.forEach((v) => {
            if (v.checked) {
              country.push(v.key);
              region.push(v.value);
            }
          });

          val = {
            [this.keyName]: {
              countryId: {
                $in: country,
              },
              provinceId: {
                $in: province,
              },
            },
          };
          detail = region;
        } else {
          const result = [];
          this.tagList.forEach((v) => {
            result.push(v.key);
            // 渠道时，是否含合并渠道，若含有则push
            if (v.channelstr) {
              const subResult = v.channelstr.split(',');
              subResult.forEach((x) => {
                result.push(x * 1);
              });
            }
          });
          // const result = this.tagList ? this.tagList.map(x => x.key) : [];
          const displayname = this.tagList ? this.tagList.map(x => x.value) : [];
          // 存储的用户属性对应的id
          val = {
            [this.keyName]: {
              [this.dataType.idname]: {
                $in: result,
              },
            },
          };
          detail = displayname;
        }
        this.$emit('change-item-data', this.keyName, val, detail);
      },
    },
    watch: {
      tagList() {
        this.getReturnData();
      },
      contentData() {
        this.renderData();
      },
    },
  };
</script>
